import React from "react";
import {Columns, Form, Heading, Table} from "react-bulma-components";
import {formatDate, getEarliestSTRateInfo, getNext15K, getSTRates, readableDate} from "../../../utils";
import FAIcon from "../../Icon/FAIcon";


class PrintContractDetails extends React.Component{



    render(){
        let data = this.props.rental;
        let vehicleMake = (data.vehicle && data.vehicle.make) ? data.vehicle.make.name : "";
        let vehicleModal = (data.vehicle && data.vehicle.model) ? data.vehicle.model.name : "";
        let customerAddress = data.customer && (data.customer.address_line1 + " " + data.customer.town);
        let payerAddress = data.payer && (data.payer.address_line1 + " " + data.payer.town);

        let customerMobile = (data.customer && data.customer.company_phone_type === "Mobile") ? (data.customer.company_phone_country_code + data.customer.company_phone) : "";
        let customerLandLine = (data.customer && data.customer.company_phone_type === "Phone") ? (data.customer.company_phone_area_code +" "+ data.customer.company_phone) : "";
        let payerPhone = data.payer ?
                            data.payer.company_phone_type === "Mobile" ? (data.payer.company_phone_country_code + data.payer.company_phone) :
                            data.payer.company_phone_type === "Phone" ? (data.payer.company_phone_area_code +" "+ data.payer.company_phone) : ""
                            : ""

        let term = data.rental_type === "LT" ?  data.term+" Weeks" : data.rental_type === "ST" ? data.days+" Days" : ""

        let stDayInfo = getEarliestSTRateInfo(data);
        // Take the earliest insurance rate for short term, for FOC and LT use the daily_insurance_charge
        const getInsRate = () => {
            if(data.rental_type === "ST"){
                if(data.apply_insurance) {
                    let dataInfo = getEarliestSTRateInfo(data);
                    return "£"+dataInfo.ins
                }
            }
            else{
                if(data.daily_insurance_charge > 0) {
                    return "£"+data.daily_insurance_charge
                }
            }
            // Default case should be blank so the space is empty on printout
            return ""
        };

        const getInsDays = () => {
            // this function exists to wrapp an if statement on when to display this number
            if(data.rental_type === "ST"){
                if(data.apply_insurance){
                    return data.days
                }
            }
            else{
                if(data.daily_insurance_charge > 0){
                    return data.days
                }
            }
            return ""
        }


        let stHireRates = getSTRates(data);
        //let ltWeeklyRate = (Math.round(((data.long_term_daily * 7) * 100))) / 100;

        let depValue = (data && data.vehicle && data.vehicle.finance_agreements && data.vehicle.finance_agreements[0]) ? (Math.round((data.vehicle.finance_agreements[0].estimated_value * 100))) / 100 : 0;
        // If the vehicle is hired in then the cost to us is a daily rate, if its purchased and finances then its a monthly cost
        // This is now entered by the user on the contract
        let weeklyVehicleCost = (data && data.vehicle && data.vehicle.finance_agreements && data.vehicle.finance_agreements[0]) ?
                                data.vehicle.finance_agreements[0].finance_type === "HIRE_AGREEMENT" ? (data.vehicle.finance_agreements[0].daily_rate * 7) :
                                    (data.vehicle.finance_agreements[0].monthly_payment / 30.42) * 7 : 0;

        weeklyVehicleCost = (Math.round((weeklyVehicleCost * 100))) / 100;

        // This only works for LT hire (this also only should be displayed for LT hire
        let daysTill15K = getNext15K(data.start_mileage, data.mileage_allowance)
        let today = new Date();
        let firstInspectionDue = new Date();
        firstInspectionDue.setDate(today.getDate() + daysTill15K);
        // Needs to figure out how often they will do 15k miles a year using the mileage allowance
        let daysBetweenInspections = 365 / (data.mileage_allowance / 15000);
        let weeksBetweenInspections = Math.floor((daysBetweenInspections / 7));

        const processDBStrings = (item) => {
            if(item) {
                // Needs to strip the underscores and make to upper case
                let strippedString = item.replace("_", " ")
                return strippedString.toUpperCase();
            }
            return ""
        }


        let rentalType = () => {
            if(data.rental_type === "FOC"){
                return "FREE OF CHARGE"
            }
            else if(data.rental_type === "ST"){
                return "SHORT TERM"
            }
            else{
                return "LONG TERM"
            }
        }

        let getDepartmentDetails = (department) => {
            let returnData = {
                name: "",
                contactInfo: "TEL: "
            }
            // Handle not getting a department
            if(!(!!department)){
                return returnData
            }

            returnData.name = returnData.name + department.name + " JCR UNITS, CHERRY TREE ROAD, TIBENHAM, NORFOLK, NR16 1PH"
            if(department.id === 4){
                returnData.contactInfo = returnData.contactInfo + "01953 528601 EMAIL: info@direct-vanhire.co.uk"
            }
            else if(department.id === 5){
                returnData.contactInfo = returnData.contactInfo + "01953 528800"
            }
            else if(department.id === 6){
                returnData.contactInfo = returnData.contactInfo + "01953 528600"
            }
            else if(department.id === 7){
                returnData.contactInfo = returnData.contactInfo + "01953 528 900"
            }

            return returnData;
        }

        let contactInformation = getDepartmentDetails(data.department);

        return (
            <div>
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"} bordered>
                            <tbody>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}>{contactInformation.name}</td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"table-header-bold border-black"}>{contactInformation.contactInfo}</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}>{`RENTAL ${rentalType()} HIRE - RENTAL AGREEMENT`}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"table-header-bold fill-black border-black"}>VEHICLE DETAILS & DAILY RATES</td>
                                    <td colSpan={6} className={"table-header-bold fill-black border-black"}>HIRER/DRIVER/INSURER OF VEHICLE</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>REGISTRATION:</td>
                                    <td colSpan={4} className={"border-black"}>{data.vehicle ? data.vehicle.registration : ""}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>NAME:</td>
                                    <td colSpan={4} className={" border-black"}>{data.customer ? data.customer.display_name : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>MAKE/MODEL:</td>
                                    <td colSpan={4} className={" border-black"}>{vehicleMake+"/"+vehicleModal}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>COMPANY:</td>
                                    <td colSpan={4} className={" border-black"}>{(data && data.customer) && data.customer.company_name}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>RETAIL VALUE:</td>
                                    <td colSpan={4} className={" border-black"}>£{depValue}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>ADDRESS:</td>
                                    <td colSpan={4} className={" border-black"}>{customerAddress}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>TERM:</td>
                                    <td colSpan={4} className={" border-black"}>{term}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POSTCODE:</td>
                                    <td colSpan={4} className={" border-black"}>{data.customer ? data.customer.postcode : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>ON HIRE DATE:</td>
                                    <td colSpan={4} className={" border-black"}>{readableDate(data.on_hire_date)}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>MOBILE:</td>
                                    <td colSpan={4} className={" border-black"}>{customerMobile}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>ON HIRE TIME:</td>
                                    <td colSpan={4} className={" border-black"}>{data.on_hire_time}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>LANDLINE:</td>
                                    <td colSpan={4} className={" border-black"}>{customerLandLine}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>OFF HIRE DATE:</td>
                                    <td colSpan={4} className={" border-black"}>{readableDate(data.off_hire_date)}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>EMAIL:</td>
                                    <td colSpan={4} className={" border-black"}>{data.customer && data.customer.company_email}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>OFF HIRE TIME:</td>
                                    <td colSpan={4} className={" border-black"}>{data.off_hire_time}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>NI NUMBER:</td>
                                    <td colSpan={4} className={" border-black"}>{data.ni_number}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>{data.rental_type === "ST" && "DAY 1-2 RATE:"}</td>
                                    <td colSpan={4} className={" border-black"}>{data.rental_type === "ST" && "£"+stHireRates.day1_2_rate}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>LICENCE #:</td>
                                    <td colSpan={4} className={" border-black"}>{data.licence_number}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>{data.rental_type === "ST" && "DAY 3-6 RATE:"}</td>
                                    <td colSpan={4} className={" border-black"}>{data.rental_type === "ST" && "£"+stHireRates.day3_6_rate}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>EXPIRY DATE:</td>
                                    <td colSpan={4} className={" border-black"}>{readableDate(data.licence_expiry_date)}</td>
                                </tr>
                                {data.rental_type === "ST" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>DAY 7-27 RATE:</td>
                                        <td colSpan={4} className={" border-black"}>£{stHireRates.day7_27_rate}</td>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>LICENCE TYPE:</td>
                                        <td colSpan={2} className={" border-black"}>{data.licence_type}</td>
                                        <td colSpan={1} className={"fill-grey border-black bold"}>CHECK:</td>
                                        <td colSpan={1} className={" border-black"}>{data.licence_checked && <FAIcon size="small" icon={["fas", "check"]}/>}</td>
                                    </tr>
                                }
                                {data.rental_type === "ST" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>DAY 28+ RATE:</td>
                                        <td colSpan={4} className={" border-black"}>£{stHireRates.day_28_plus_rate}</td>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>PERIOD HELD:</td>
                                        <td colSpan={2} className={" border-black"}>{data.licence_held ? data.licence_held : ""}</td>
                                        <td colSpan={1} className={"fill-grey border-black bold"}>COPY TAKEN:</td>
                                        <td colSpan={1} className={" border-black"}>{data.licence_copy_taken && <FAIcon size="small" icon={["fas", "check"]}/>}</td>
                                    </tr>
                                }
                                {data.rental_type === "LT" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}></td>
                                        <td colSpan={4} className={" border-black"}></td>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>LICENCE TYPE:</td>
                                        <td colSpan={2} className={" border-black"}>{data.licence_type}</td>
                                        <td colSpan={1} className={"fill-grey border-black bold"}>CHECK:</td>
                                        <td colSpan={1} className={" border-black"}>{data.licence_checked && <FAIcon size="small" icon={["fas", "check"]}/>}</td>
                                    </tr>
                                }
                                {data.rental_type === "LT" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}></td>
                                        <td colSpan={4} className={" border-black"}></td>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>PERIOD HELD:</td>
                                        <td colSpan={2} className={" border-black"}>{data.licence_held ? data.licence_held : ""}</td>
                                        <td colSpan={1} className={"fill-grey border-black bold"}>COPY TAKEN:</td>
                                        <td colSpan={1} className={" border-black"}>{data.licence_copy_taken && <FAIcon size="small" icon={["fas", "check"]}/>}</td>
                                    </tr>
                                }
                                {data.rental_type === "LT" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>LONG TERM DAILY:</td>
                                        <td colSpan={4} className={" border-black"}>£{data.long_term_daily}</td>
                                        <td colSpan={2} className={"fill-grey out-border-top-black out-border-middle-black bold"}>SIGN TO CONFIRM LICENCE STATUS:</td>
                                        <td colSpan={4} className={" out-border-top-black out-border-middle-black"}></td>
                                    </tr>
                                }
                                {data.rental_type === "LT" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>CHARGEABLE FROM:</td>
                                        <td colSpan={4} className={" border-black"}>{readableDate(data.chargeable_date)}</td>
                                        <td colSpan={2} className={"fill-grey out-border-middle-black out-border-bottom-black bold"}></td>
                                        <td colSpan={4} className={" out-border-middle-black out-border-bottom-black"}></td>
                                    </tr>
                                }
                                {data.rental_type !== "LT" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>CHARGEABLE FROM:</td>
                                        <td colSpan={4} className={" border-black"}>{readableDate(data.chargeable_date)}</td>
                                        <td colSpan={2} className={"fill-grey out-border-top-black out-border-middle-black bold"}>SIGN TO CONFIRM LICENCE STATUS:</td>
                                        <td colSpan={4} className={" out-border-top-black out-border-middle-black"}></td>
                                    </tr>
                                }
                                {data.rental_type === "ST" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>HIRE TOTAL:</td>
                                        <td colSpan={4} className={"border-black"}>£{data.short_term_total}</td>
                                        <td colSpan={2} className={"fill-grey border-black"}></td>
                                        <td colSpan={4} className={"out-border-middle-black out-border-bottom-black"}></td>
                                    </tr>
                                }
                                <tr>
                                    <td colSpan={6} className={"fill-black border-black table-header-bold"}>INSURANCE</td>
                                    <td colSpan={6} className={"fill-black border-black table-header-bold"}>PAYER/HIRER (IF DIFFERENT FROM DRIVER)</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>OUR INSURANCE:</td>
                                    <td colSpan={4} className={" border-black"}>{data.on_hire_insurance_completed !== "NOT_REQUIRED" ? <FAIcon size="small" icon={["fas", "check"]}/> : "X"}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>NAME:</td>
                                    <td colSpan={4} className={" border-black"}>{data.payer && data.payer.display_name}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>YES - COVER PER DAY</td>
                                    <td colSpan={2} className={" border-black"}>{getInsRate()}</td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>DAYS:</td>
                                    <td colSpan={1} className={" border-black"}>{getInsDays()}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>ADDRESS:</td>
                                    <td colSpan={4} className={" border-black"}>{payerAddress}</td>
                                </tr>
                                {data.rental_type === "ST" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>INSURANCE ADMIN FEE PER DAY:</td>
                                        <td colSpan={4} className={"border-black"}>£{stDayInfo.admin}</td>
                                        <td colSpan={2} className={"fill-grey border-black"}></td>
                                        <td colSpan={4} className={"border-black"}></td>
                                    </tr>
                                }
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POLICY NAME:</td>
                                    <td colSpan={4} className={" border-black"}>{data.policy_name}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}></td>
                                    <td colSpan={4} className={" border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>INSURER:</td>
                                    <td colSpan={4} className={" border-black"}>{data.insurer}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POSTCODE:</td>
                                    <td colSpan={4} className={" border-black"}>{data.payer ? data.payer.postcode : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POLICY NUMBER:</td>
                                    <td colSpan={4} className={" border-black"}>{data.policy_number}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>PHONE NUMBER:</td>
                                    <td colSpan={4} className={" border-black"}>{payerPhone}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>EXPIRY DATE:</td>
                                    <td colSpan={4} className={" border-black"}>{readableDate(data.insurance_expiry)}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>EMAIL:</td>
                                    <td colSpan={4} className={" border-black"}>{data.payer ? data.payer.comapany_email : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>INSURANCE EXCESS:</td>
                                    <td colSpan={4} className={" border-black"}>{data.insurance_excess ? "£"+data.insurance_excess : "-"}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>SIGN TO ACCEPT LIABILITY FOR ALL PAYMENTS TO BE MADE ON TIME FOR THIS HIRE:</td>
                                    <td colSpan={4} className={" border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"fill-black border-black table-header-bold"}>{data.rental_type === "LT" ? "LONG TERM LEASE HIRE FOR 12 MONTHS MINIMUM" : rentalType()}</td>
                                    <td colSpan={6} className={"fill-black border-black table-header-bold"}>HIRE CONDITIONS & CHARGES:</td>
                                </tr>
                                {data.rental_type === "LT" &&
                                    <tr>
                                        <td colSpan={10} className={"fill-grey border-black bold"}>EARLY RETURN CHARGE PER WEEK TO END OF THE TERM - PAYABLE ON RETURN (+VAT)</td>
                                        <td colSpan={2} className={" border-black"}>£{data.early_return_penalty}</td>
                                    </tr>
                                }
                                {data.rental_type === "LT" &&
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black bold"}>£50 PER MONTH FAIR WEAR & TEAR ALLOWANCE - USED AGAINST OF HIRE REPAIRS (MIN 12 MONTH HIRE REQUIRED)</td>
                                </tr>
                                }
                                {data.rental_type !== "LT" &&
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black bold"}>ADVISORY: PLEASE REMOVE ANY PERSONAL DATA/ DEVICES FROM THE INFOTAINMENT SYSTEMS</td>
                                </tr>
                                }
                                {data.rental_type === "ST" &&
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black bold"}>DEPOSIT REFUND CAN TAKE UP TO 14 WORKING DAYS TO REACH YOUR BANK</td>
                                </tr>
                                }
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <Form.Textarea
                                            value={data.contract_comments}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>{`MILEAGE ALLOWANCE ${data.rental_type === "LT" ? "P/A" : "P/D"}`}</td>
                                    <td colSpan={4} className={" border-black"}>{data.mileage_allowance}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>EXCESS MILEAGE CHARGE</td>
                                    <td colSpan={4} className={" border-black"}>£{data.excess_mileage_charge_per_mile + " Per Mile"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>DEPOSIT:</td>
                                    <td colSpan={4} className={"border-black"}>£{data.deposit || 0}</td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>PAID:</td>
                                    <td colSpan={1} className={"border-black"}>{data.customer_deposit_paid_amount > 0 && <FAIcon size="small" icon={["fas", "check"]}/>}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>DATE:</td>
                                    <td colSpan={2} className={" border-black"}>{readableDate(data.deposit_paid_date)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>INITIAL PAYMENT:</td>
                                    <td colSpan={4} className={" border-black"}>£{data.initial_payment}</td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>PAID:</td>
                                    <td colSpan={1} className={"border-black"}>{data.customer_initial_payment_paid_amount > 0 && <FAIcon size="small" icon={["fas", "check"]}/>}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>DATE:</td>
                                    <td colSpan={2} className={"border-black"}>{readableDate(data.initial_payment_date)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>PAYMENT TYPE:</td>
                                    <td colSpan={4} className={" border-black"}>{data.payment_method !== "blank" && processDBStrings(data.payment_method)}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>PAYMENT SCHEDULE:</td>
                                    <td colSpan={4} className={" border-black"}>{data.customer_payment_interval !== "blank" && processDBStrings(data.customer_payment_interval)}</td>
                                </tr>
                                {data.rental_type === "LT" &&
                                    <tr>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>ESTIMATED FIRST INSPECTION DUE:</td>
                                        <td colSpan={4} className={" border-black"}>{readableDate(formatDate(firstInspectionDue))}</td>
                                        <td colSpan={2} className={"fill-grey border-black bold"}>15K INSPECTION DUE EVERY (WEEKS):</td>
                                        <td colSpan={4} className={" border-black"}>{weeksBetweenInspections} Weeks</td>
                                    </tr>
                                }
                                <tr>
                                    <td colSpan={6} className={"fill-grey border-black bold"}>EXPECTED RETURN / HIRE COMMENTS:</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>D/C CHARGE:</td>
                                    <td colSpan={4} className={" border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-black out-border-top-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-black out-border-bottom-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>FLEET NUMBER:</td>
                                    <td colSpan={4} className={"border-black"}>{data.vehicle ? data.vehicle.fleet_number : "-"}</td>
                                    <td colSpan={6} className={"fill-grey border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>SIGNED BY CUSTOMER/DRIVER</td>
                                    <td colSpan={4} className={" border-black"}></td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>SIGNED BY {data.department ? data.department.name : ""}</td>
                                    <td colSpan={4} className={" border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>NAME:</td>
                                    <td colSpan={4} className={" border-black"}></td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>PRINT NAME</td>
                                    <td colSpan={4} className={" border-black"}></td>
                                </tr>
                                <tr>

                                    <td colSpan={2} className={"fill-grey border-black bold"}>TRACKER:</td>
                                    <td colSpan={4} className={"border-black"}></td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>OFF QBE:</td>
                                    <td colSpan={1} className={"border-black"}></td>
                                    {data.rental_type !== "LT" &&
                                        <td colSpan={2} className={"fill-grey border-black bold"}>ON ALLIANZ:</td>
                                    }
                                    {data.rental_type !== "LT" &&
                                        <td colSpan={3} className={"border-black"}></td>
                                    }
                                    {data.rental_type === "LT" &&
                                        <td colSpan={2} className={"fill-grey border-black bold"}>INSPECTIONS:</td>
                                    }
                                    {data.rental_type === "LT" &&
                                        <td colSpan={3} className={"border-black"}></td>
                                    }
                                </tr>
                                {this.props.customer_copy &&
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}><Heading>CUSTOMER COPY</Heading></td>
                                </tr>
                                }
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </div>
        )
    }
}
export default PrintContractDetails;